import React from 'react';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import Contact from './Contact.jsx';

const ContactUs = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Header />
            <Contact />
            <Footer />
        </div>
    );
};

export default ContactUs; 